import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { GetAnnouncementsAction } from '../../actions/announcements/get-announcements-action';
import { GetAnnouncementsSuccessAction } from '../../actions/announcements/get-announcements-success-action';
import { GetAnnouncementsErrorAction } from '../../actions/announcements/get-announcements-error-action';

@Injectable()
export class GetAnnouncementsEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public GetAnnouncementsActions = createEffect(() => this.actions
    .pipe(
      ofType(GetAnnouncementsAction.type),
      mergeMap(action => {
        const getAnnouncementsAction = <GetAnnouncementsAction>action;
        return this.api.getAnnouncements(getAnnouncementsAction.bijbEvent, getAnnouncementsAction.horizon).then(notifs => {
          return new GetAnnouncementsSuccessAction(notifs);
        }, error => {
          return new GetAnnouncementsErrorAction({ ...error, fatal: true });
        });
      })
    ));
}
